(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-callouts-banner"] && !Shopify.designMode) return;
  try {
    
  gsap.from('.value-props__item', { 
    x: -20,
    opacity: 0,
    duration: 1,
    ease: 'sine',
    stagger: {
      each: .3,
      from: 'end'
    },
    scrollTrigger: {
      trigger: '.value-props__item',
      start: "top 80%"
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["divider"] && !Shopify.designMode) return;
  try {
    
  gsap.from('.divider__line-1', { 
    rotation: -.5,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.divider__line-2', { 
    rotation: .5,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  const newsletterPopup = document.querySelector('.newsletter-popup-wrapper');
  const newsletterPopupClose = document.querySelector('.newsletter-popup__close');
  const newsletterPopupOpen = document.querySelectorAll('[href="#open-newsletter"]');

  if (newsletterPopup) {

    if (getCookie('newsletterCookie')) {
      fadeOut(newsletterPopup, 400)
    } else {
      const delay = (Number(newsletterPopup.dataset.delay) * 1000) || 5000;

      setTimeout(function() {
        fadeIn(newsletterPopup, 400, 'flex');
      }, delay);
    }

    newsletterPopupClose.addEventListener('click', event => {
      const day = 1;

      fadeOut(newsletterPopup, 400)
      setCookie('newsletterCookie', true, day);
    });

    newsletterPopupOpen.forEach(btn => {
      btn.addEventListener('click', event => {
        newsletterPopup.classList.add('is-visible');
      });
    });

  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-products"] && !Shopify.designMode) return;
  try {
    
  // Animations
  let exploreTL = gsap.timeline({
    scrollTrigger: {
      duration: 1,
      trigger: '.explore-products__images-wrapper',
      start: "top 80%"
    }
  });

  animateImageSection(1);
  function animateImageSection(idx) {
    exploreTL.from(`.explore-products__images-wrapper[data-index="${idx}"]`, {
      opacity: 0,
      y: 25,
      delay: .35
    })
    .to(`.explore-products__arrow-1[data-index="${idx}"]`, {
      x: 0,
      opacity: 1
    }, '<90%')
    .to(`.explore-products__arrow-2[data-index="${idx}"]`, {
      x: 0,
      opacity: 1
    }, '<90%');
  }

  gsap.fromTo('.explore-products__line',
    {
      drawSVG: '0% 0%'
    },
    {
      drawSVG: '0% 100%',
      duration: 3.5,
      delay: 1,
      scrollTrigger: {
        trigger: '.explore-products__line',
        start: "top 80%"
      }
    }
  );

  const exploreInfoSlider = new Swiper('.explore-products__information-wrapper', {
    loop: false,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  const exploreImageSlider = new Swiper('.explore-products__images-wrapper', {
    loop: false,
    spaceBetween: 20,
    effect: 'fade',
    allowTouchMove: false,
    speed: 800
  });

  const exploreTabs = document.querySelectorAll('.explore-products__tab');
  exploreTabs.forEach(tab => {
    tab.addEventListener('click', event => {
      const activeSibling = event.target.parentElement.querySelector('.active');
      const idx = Number(event.target.dataset.idx);
      
      // Active tab state
      activeSibling.classList.remove('active');
      event.target.classList.add('active');

      // Sync with sliders 
      exploreInfoSlider.slideTo(idx);
      exploreImageSlider.slideTo(idx);

      // Run Animation
      animateImageSection(idx + 1);
    });
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  // Animations
  let exploreTL = gsap.timeline({
    scrollTrigger: {
      duration: 1,
      trigger: '.Featured_Product_Section .product__media-wrapper .product__media-list',
      start: "top 80%"
    }
  });

  animateImageSection(1);
  function animateImageSection(idx) {
    exploreTL.from(`.Featured_Product_Section .product__media-wrapper .product__media-list[data-index="${idx}"]`, {
      opacity: 0,
      y: 25,
      delay: .35
    })
    .to(`.explore-products__arrow-1[data-index="${idx}"]`, {
      x: 0,
      opacity: 1
    }, '<90%')
    .to(`.explore-products__arrow-2[data-index="${idx}"]`, {
      x: 0,
      opacity: 1
    }, '<90%');
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const footerDropdowns = document.querySelectorAll('.footer-block__heading-container');

  footerDropdowns.forEach(footerButton => {
    footerButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.footer-block__details-content');
      const activeDropdown = document.querySelector('.footer-block--menu.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.footer-block__details-content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Transparent header
  const header = document.querySelector('.navigation-wrapper');
  let scrollPosition = window.scrollY;

  if (scrollPosition > 5) {
    header.classList.add('scrolled')
  } else {
    header.classList.remove('scrolled')
  }

  document.addEventListener('scroll', () => {
    scrollPosition = window.scrollY;

    if (scrollPosition > 5) {
      header.classList.add('scrolled')
    } else {
      header.classList.remove('scrolled')
    }
  });

  // Megamenu overlay
  const height = document.querySelector('.navigation-wrapper').offsetHeight;
  const overlays = document.querySelectorAll('.header__mega-menu-overlay');
  overlays.forEach(overlay => {
    overlay.style.top = `${height}px`;
  })
  
  // Megamenu hover categories
  const hoverCategories = document.querySelectorAll('.header__mega-menu-category');

  hoverCategories.forEach(hoverCategory => {
    hoverCategory.addEventListener('mouseenter', event => {
      const tab = event.currentTarget.dataset.tab;
      const activeHoverCategory = event.currentTarget.parentElement.querySelector('.header__mega-menu-category.active');

      activeHoverCategory.classList.remove('active');
      event.currentTarget.classList.add('active');

      const categorySections = document.querySelectorAll('.header__mega-menu-category-products');
      const activeSection = document.querySelector('.header__mega-menu-category-products.active');
      const targetSection = document.querySelector(`.header__mega-menu-category-products[data-tab="${tab}"]`);

      activeSection.classList.remove('active');
      targetSection.classList.add('active');
    });
  });

  // Search
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  openSearch.addEventListener('click', () => {
    if (search.classList.contains('is-visible')) {
      search.classList.remove('is-visible');
    } else {
      search.classList.add('is-visible');
    }
  });

  closeSearch.addEventListener('click', () => {
    search.classList.remove('is-visible');
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-discounts"] && !Shopify.designMode) return;
  try {
    
  // Prevent scrolling to top of page
  const links = document.querySelectorAll('.hero-discounts__block-button');
  links.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  
  const heroSlider = new Swiper('.hero__slider', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    allowTouchMove: true, 
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.hero__pagintation',
      clickable: true
    },
    breakpoints: {
      768: {
        allowTouchMove: false
      }
    },
    on: {
      init: function () {
        var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var elementWithDataIdx0 = document.querySelector('.hero__image[data-idx="0"]');
        if (windowWidth < 768) {
          var firstImageRatio = elementWithDataIdx0.querySelector('.aspect-ratio.hide-desktop');
        } 
        else {
          var firstImageRatio = elementWithDataIdx0.querySelector('.aspect-ratio.hide-mobile');
        }        
        var firstImagecomputedStyle = window.getComputedStyle(firstImageRatio);
        var firstImagepaddingBottom = parseFloat(firstImagecomputedStyle.paddingBottom);

        var image_adaptiv_one = document.querySelector('.image_adaptive');

        if (image_adaptiv_one) {
          document.querySelector('.image_adaptive').style.height = firstImagepaddingBottom + 'px';
        }
      },
    }
  });
  
  function aspectHeight(activeImage) {
    console.log('Script is running 555');
    
   var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
     if (windowWidth < 768) {
      var aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-desktop');
    } 
    else {
      var aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-mobile');
    }
    var computedStyle = window.getComputedStyle(aspectRatioElement);
    var paddingBottom = parseFloat(computedStyle.paddingBottom);
    

    var image_adaptive = document.querySelector('.image_adaptive');

    if(image_adaptive){
      document.querySelector('.image_adaptive').style.height = paddingBottom + 'px';    
    }
    
  }
  
  heroSlider.on('slideChange', function (slider) {
    const idx = slider.realIndex;
    document.querySelector('.hero__image.active').classList.remove('active');
    var activeImage = document.querySelector(`.hero__image[data-idx="${idx}"]`);
    activeImage.classList.add('active');
    aspectHeight(activeImage);
  });  
  
  window.addEventListener('resize', () => {
    var activeUpdateImage = document.querySelector('.hero__image.active');
    aspectHeight(activeUpdateImage);
  });

  gsap.from('.opaque-white-shape', { 
    y: 30,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.transparent-white-shape', { 
    y: -20,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.set('.hero__svg .line', { visibility: 'visible' });
  gsap.fromTo('.hero__svg .line',
    { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
    { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
  );
  
  gsap.from('.hero__svg .line-1', { 
    y: -35,
    duration: 5,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.hero__svg .line-2', { 
    y: -15,
    duration: 5,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });



//$$$$$$$$$***** Updated Code

// Function to adjust image height based on aspect ratio
// function aspectHeight(activeImage) {
//     console.log('Script is running 555');

//     var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

//     var aspectRatioElement;
//     if (windowWidth < 768) {
//         aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-desktop');
//     } else {
//         aspectRatioElement = activeImage.querySelector('.aspect-ratio.hide-mobile');
//     }

//     if (!aspectRatioElement) return; // Avoid errors if element is missing

//     var computedStyle = window.getComputedStyle(aspectRatioElement);
//     var paddingBottom = parseFloat(computedStyle.paddingBottom);

//     var imageAdaptive = document.querySelector('.image_adaptive');

//     if (imageAdaptive) {
//         imageAdaptive.style.height = paddingBottom + 'px';
//     }
// }

// Initialize Swiper (heroSlider)
// var heroSlider = new Swiper('.hero-slider', {
//     loop: true,
//     slidesPerView: 1,
//     on: {
//         init: function () {
//             const idx = this.realIndex;
//             var activeImage = document.querySelector(`.hero__image[data-idx="${idx}"]`);
//             if (activeImage) {
//                 activeImage.classList.add('active');
//                 aspectHeight(activeImage);
//             }
//         }
//     }
// });

// Slide change event
// heroSlider.on('slideChange', function (slider) {
//     const idx = slider.realIndex;

//     var currentActive = document.querySelector('.hero__image.active');
//     if (currentActive) currentActive.classList.remove('active');

//     var activeImage = document.querySelector(`.hero__image[data-idx="${idx}"]`);
//     if (activeImage) {
//         activeImage.classList.add('active');
//         aspectHeight(activeImage);
//     }
// });

// Window resize handler
// window.addEventListener('resize', () => {
//     var activeUpdateImage = document.querySelector('.hero__image.active');
//     if (activeUpdateImage) {
//         aspectHeight(activeUpdateImage);
//     }
// });

// GSAP animations
// gsap.from('.opaque-white-shape', { 
//     y: 30,
//     duration: 4,
//     ease: 'linear',
//     repeat: -1,
//     yoyo: true
// });

// gsap.from('.transparent-white-shape', { 
//     y: -20,
//     duration: 4,
//     ease: 'linear',
//     repeat: -1,
//     yoyo: true
// });

// gsap.set('.hero__svg .line', { visibility: 'visible' });

// gsap.fromTo('.hero__svg .line',
//     { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
//     { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
// );

// gsap.from('.hero__svg .line-1', { 
//     y: -35,
//     duration: 5,
//     ease: 'linear',
//     repeat: -1,
//     yoyo: true
// });

// gsap.from('.hero__svg .line-2', { 
//     y: -15,
//     duration: 5,
//     ease: 'linear',
//     repeat: -1,
//     yoyo: true
// });



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
    if( document.querySelector(".image-banner__stroke") ){
        gsap.set('.image-banner__stroke .page-divider .divider-line', { visibility: 'visible' });
        gsap.fromTo('.image-banner__stroke.line-position-top .divider-line',
            { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
            { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
        );

        gsap.fromTo('.image-banner__stroke.line-position-bottom .divider-line',
            { drawSVG: '0% 0%', duration: 3.5, delay: 1 },
            { drawSVG: '100% 0%', duration: 3.5, delay: 1 }
        );

        gsap.from('.image-banner__stroke .divider__line-1', { 
            rotation: -.5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });

        gsap.from('.image-banner__stroke .divider__line-2', { 
            rotation: .5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  const legalPopup = document.querySelector('.legal-popup');
  const legalPopupClose = document.querySelector('.legal-popup__close');

  if (getCookie('legalCookie')) {
    legalPopup.classList.remove('is-visible');
  } else {
    legalPopup.classList.add('is-visible');
  }

  legalPopupClose.addEventListener('click', event => {
    const day = legalPopup.dataset.day;

    legalPopup.classList.remove('is-visible');
    setCookie('legalCookie', true, day);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  gsap.set('.main-blog__lines .line', { visibility: 'visible' });
  gsap.fromTo('.main-blog__lines .line',
    { drawSVG: '100% 100%', duration: 3.5, delay: .25 },
    { drawSVG: '0% 100%', duration: 3.5, delay: .25 }
  );

  gsap.from('.main-blog__line-1', { 
    y: -25,
    duration: 4,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  gsap.from('.main-blog__line-2', { 
    y: -15,
    duration: 5,
    ease: 'linear',
    repeat: -1,
    yoyo: true
  });

  // Handle dropdown
  const dropdowns = document.querySelectorAll('.main-blog__filters-dropdown-button');
  dropdowns.forEach(dropdown => {
    dropdown.addEventListener('click', event => {
      dropdown.classList.toggle('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
 
  
  // Product zoom slider
  const productZoomSlider = new Swiper('.product__zoom-slider', {
    loop: true,
    pagination: {
      el: '.product__zoom-pagination',
    },
    navigation: {
      nextEl: '.product__zoom-button.swiper-button-next',
      prevEl: '.product__zoom-button.swiper-button-prev',
    }
  });

  const zoomContainer = document.querySelector('.product__zoom');
  const zoomButtons = document.querySelectorAll('.product__media-zoom');
  zoomButtons.forEach(zoomButton => {
    zoomButton.addEventListener('click', event => {
      const position = Number(event.currentTarget.dataset.position) - 1;
      
      productZoomSlider.slideToLoop(position);
      setTimeout(() => {
        zoomContainer.classList.add('open');
      }, 250);
    });
  });

  const zoomClose = document.querySelector('.product__zoom-close');
  zoomClose.addEventListener('click', event => {
    zoomContainer.classList.remove('open');
  });

  // Product option dropdowns
  const formDropdownButtons = document.querySelectorAll('.product-form__dropdown-text');
  formDropdownButtons.forEach(formDropdownButton => {
    formDropdownButton.addEventListener('click', event => {
      event.preventDefault();
   
      const dropdown = event.currentTarget.nextElementSibling;
      const parent = event.currentTarget.parentElement;
  
      if (parent.classList.contains('active')) {
        parent.classList.remove('active');
        slideUp(dropdown);
      } else {
        parent.classList.add('active');
        slideDown(dropdown, 200)
      }
    }); 
  });
  
  const formDropdownLabels = document.querySelectorAll('.product-form__dropdown-container input[type=radio]+label');
  formDropdownLabels.forEach(formDropdownLabel => {
    formDropdownLabel.addEventListener('click', event => {
  
      const parent = formDropdownLabel.closest('.product-form__dropdown-wrapper')  
      const currentText = formDropdownLabel.innerHTML;
      const newText = parent.querySelector('.product-form__dropdown-text span');
  
      newText.innerHTML = currentText;
  
      const activeDropdown = parent.querySelector('.product-form__dropdown-container')
      parent.classList.remove('active'); 
      slideUp(activeDropdown, 200);
    }); 
  });
  
  
  // Product dropdowns
  const dropdownButtons = document.querySelectorAll('.product__dropdown-header');

  dropdownButtons.forEach(dropdownButton => {
    dropdownButton.addEventListener('click', event => {
      const parent = event.currentTarget.parentElement;
      const content = parent.querySelector('.product__dropdown-content');
      const activeDropdown = document.querySelector('.product__dropdown.active');

      if (!parent.classList.contains('active')) {
        if (activeDropdown) {
          const activeContent = activeDropdown.querySelector('.product__dropdown-content');

          activeDropdown.classList.remove('active');
          slideUp(activeContent, 300);
        }

        parent.classList.add('active');
        slideDown(content, 300);
      } else {
        parent.classList.remove('active');
        slideUp(content, 300);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal"]) return;
  try {
    
    if( document.querySelector(".modal__header-shapes-svg") ){
        gsap.set('.modal__header-shapes-line', { visibility: 'visible' });
        gsap.fromTo('.modal__header-shapes-line',
            { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
            { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
        );
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-header-banner"] && !Shopify.designMode) return;
  try {
    
    if( document.querySelector(".page-header-banner__stroke") ){
        gsap.set('.page-header-banner__stroke .page-divider .divider-line', { visibility: 'visible' });

        if(document.querySelector('.page-header-banner__stroke.line-position-top .divider-line')){
            gsap.fromTo('.page-header-banner__stroke .divider-line',
            { drawSVG: '0 0', duration: 3.5, delay: 1 },
            { drawSVG: '100% 0', duration: 3.5, delay: 1 }
        )
        } else if( document.querySelector('.page-header-banner__stroke .divider-line')){
            gsap.fromTo('.page-header-banner__stroke .divider-line',
                { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
                { drawSVG: '0 100% ', duration: 3.5, delay: 1 }
            )
        }

        gsap.from('.page-header-banner__stroke .divider__line-1', {
            rotation: -.5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });

        gsap.from('.page-header-banner__stroke .divider__line-2', {
            rotation: .5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-header-grid"]) return;
  try {
    
    if( document.querySelector(".page-header-grid__shape") ){
        gsap.set('.page-header-grid__svg-line', { visibility: 'visible' });
        gsap.fromTo('.page-header-grid__svg-line',
            { drawSVG: '100% 100%', duration: 3.5, delay: 1 },
            { drawSVG: '0% 100%', duration: 3.5, delay: 1 }
        );
        gsap.from('.page-header-grid__svg .light-teal-shape', { 
            y: 10,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
        gsap.from('.page-header-grid__svg .dark-teal-shape', { 
            y: -20,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
        gsap.from('.page-header-grid__svg .line-1', {
            rotation: -.5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });

        gsap.from('.page-header-grid__svg .line-2', { 
            rotation: .5,
            duration: 4,
            ease: 'linear',
            repeat: -1,
            yoyo: true
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-comparison"] && !Shopify.designMode) return;
  try {
    
  const comparisonSlider = new Swiper('.pdp-comparison__charts-mobile', {
    slidesPerView: 2,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-specs"] && !Shopify.designMode) return;
  try {
    
  // Tabs
  const specsTabs = document.querySelectorAll('.pdp-specs__tab');
  
  specsTabs.forEach(specTab => {
    specTab.addEventListener('click', event => {
      const tab = event.currentTarget.dataset.tab;
      console.log(tab)

      document.querySelector('.pdp-specs__tab.active').classList.remove('active');
      event.currentTarget.classList.add('active');

      console.log(document.querySelector('.pdp-specs__item.active'))
      document.querySelector('.pdp-specs__item.active').classList.remove('active');
      document.querySelector(`.pdp-specs__item[data-tab="${tab}"]`).classList.add('active');
    });
  });

  // Specs mobile slider
  const specsSlider = document.querySelector('.pdp-specs__specs-images');
  let specsSliderInstance = {};
  const settingsSlider = {
    spaceBetween: 15,
    loop: true,
    pagination: {
      el: '.pdp-specs__pagination',
    }
  }

  window.addEventListener('load', specsSwiperOnLoadOrResize);
  window.addEventListener('resize', specsSwiperOnLoadOrResize);

  function specsSwiperOnLoadOrResize() {
    if (window.innerWidth > 768) {
      if (specsSlider.classList.contains('swiper-initialized')) {
        specsSliderInstance.destroy({
          deleteInstance: true,
          cleanStyles: true
        });
      }
    } else {
      if (!specsSlider.classList.contains('swiper-initialized')) {
        specsSliderInstance = new Swiper('.pdp-specs__specs-images', settingsSlider);
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-x-series-comparison"] && !Shopify.designMode) return;
  try {
    
  const comparisonSlider = new Swiper('.pdp-comparison__charts-mobile', {
    slidesPerView: 2,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"] && !Shopify.designMode) return;
  try {
    
  // Show product bar / hide menu
  const changePoint = document.querySelector('.product').clientHeight - 100;
  const productBar = document.querySelector('.product-bar-wrapper');
  let fromTop = window.scrollY;
  let barIsVisible = productBar.classList.contains('is-visible');

  handleBarVisibility()

  window.addEventListener('scroll', (event) => {
    fromTop = window.scrollY;
    barIsVisible = productBar.classList.contains('is-visible');

    handleBarVisibility()
  });

  function handleBarVisibility() {
    if (fromTop > changePoint) {
      if (!barIsVisible) {
        productBar.classList.add('is-visible');
      }
    } else {
      if (barIsVisible) {
        productBar.classList.remove('is-visible');
      }
    }
  }

  const links = document.querySelectorAll('.product-bar__navigation-item');
  const barHeight = productBar.clientHeight;

  // Highlight on scroll
  window.addEventListener('scroll', (event) => {
    const fromTop = window.scrollY;

    links.forEach(link => {
      const section = document.querySelector(`#${link.dataset.tab}`);

      if (section) {
        if ((section.offsetTop - barHeight - 30) <= fromTop && (section.offsetTop - barHeight - 30) + section.clientHeight > fromTop) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      }
    });
  });

  // Scroll to link
  links.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      const section = document.querySelector(`#${event.currentTarget.dataset.tab}`)

      window.scrollTo({
        top: section.offsetTop - barHeight - 30,
        behavior: "smooth"
      });
    });
  });

  // Change selections (scroll to top)
  const scrollToTop = document.querySelector('.product-bar__to-top');

  scrollToTop.addEventListener('click', function() {
    window.scroll({
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    }), 2000;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  var productSliders = [];
  [...document.querySelectorAll('.product-slider__collection')].forEach((el, i) => {
    var tab = '#' + el.dataset.tab;

    productSliders[i] = new Swiper(tab, {
      slidesPerView: 1.15,
      loop: false,
      spaceBetween: 20,
      watchOverflow: true,
      speed: 400,
      threshold: 15,
      watchSlidesProgress: true,
      navigation: {
        prevEl: tab + '--arrow-left',
        nextEl: tab + '--arrow-right'
      },
      breakpoints: {
        601: {
          slidesPerView: 2.1
        },
        1024: {
          slidesPerView: 2.6
        },
        1280: {
          slidesPerView: 3
        },
        1600: {
          slidesPerView: 4
        }
      }
    });
  });

  // Tab change
  [...document.querySelectorAll('.product-slider__tab')].forEach((el, i) => {
    el.addEventListener('click', event => {
      const el = event.target;
      const tab = el.dataset.tab; 

      if (!el.classList.contains('active')) {
        document.querySelector('.product-slider__tab.active').classList.remove('active');
        el.classList.add('active');

        document.querySelector('.product-slider__collection-wrapper.active').classList.remove('active');
        document.querySelector(`.product-slider__collection-wrapper[data-tab="${tab}"]`).classList.add('active'); 
      }
    }); 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-how-to"] && !Shopify.designMode) return;
  try {
    
const rewardsHowToSlider = new Swiper('.rewards-how-to__grid', {
  slidesPerView: 1,
  watchOverflow: true,
  loop: false,
  spaceBetween: 20,
  speed: 600,
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 80
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rewards-program"] && !Shopify.designMode) return;
  try {
    
const rewardsProgramSlider = new Swiper('.rewards-program__mobile-table', {
  slidesPerView: 1.8,
  centeredSlides: true,
  loop: true,
  spaceBetween: 0,
  speed: 600
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  const exploreImageSlider = new Swiper('.shop-by-category__container', {
    slidesPerView: 1.15,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    enabled: true, 
    breakpoints: {
      768: {
        slidesPerView: 3,
        enabled: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-blocks"] && !Shopify.designMode) return;
  try {
    
    const testimonialBlockSlider = new Swiper('.testimonial-blocks__container', {
    slidesPerView: 1,
    spaceBetween: 20,
    allowTouchMove: true,
    pagination: {
      el: '.testimonial-blocks .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  const testimonialLogoSlider = new Swiper('.testimonial-slider__logo-container', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    effect: 'fade',
    speed: 600,
    allowTouchMove: true, 
    fadeEffect: {
      crossFade: true
    },
    breakpoints: {
      768: {
        speed: 1000
      }
    }
  });

  const testimonialSlider = new Swiper('.testimonial-slider__container', {
    slidesPerView: 1,
    watchOverflow: true,
    loop: true,
    spaceBetween: 20,
    speed: 600,
    autoplay: {
      delay: 3000
    },
    navigation: {
      prevEl: '.testimonial-slider .swiper-button-prev',
      nextEl: '.testimonial-slider .swiper-button-next'
    },
    pagination: {
      el: '.testimonial-slider .swiper-pagination'
    },
    controller: {
      control: testimonialLogoSlider
    },
    breakpoints: {
      768: {
        speed: 1000
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-props"] && !Shopify.designMode) return;
  try {
    
  gsap.from('.value-props__item', { 
    x: -20,
    opacity: 0,
    duration: 1,
    ease: 'sine',
    stagger: {
      each: .3,
      from: 'end'
    },
    scrollTrigger: {
      trigger: '.value-props__item',
      start: "top 80%"
    }
  });

  } catch(e) { console.error(e); }
})();
})();
